var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "tr",
    { class: "c-list-row " + _vm.cssClasses, attrs: { id: _vm.row.id } },
    [
      _vm._l(_vm.row.items, function(item) {
        return [
          _c(
            "list-item",
            _vm._b(
              { ref: "listItem", refInFor: true },
              "list-item",
              item,
              false
            )
          )
        ]
      }),
      _vm._v(" "),
      _vm._t("last-item")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }